import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IUserDetails, Step } from "src/types";
import { RootState } from "src/redux/store";
import { useGetStep } from "src/hooks";
import {
  useNavigate,
} from 'react-router-dom';
import DocumentsUpload from "./documentsUpload";
import PersonalDetailsEdit from "./personalDetailsEdit";

type IDocument = "pan_image_upload" | "signature" | "income_proof"

export type IDocumentsToUpload = IDocument[] | []

export const Modification = () => {
  const userDetails : IUserDetails = useSelector((state: RootState) => state.account.userDetails)
  const [modificationSteps, setModificationSteps] = useState<Step[]>([])
  const [modificationScreens, setModificationScreens] = useState<string[]>([])
  const [modificationScreenIndex, setModificationScreenIndex] = useState<number>(0)
  const [documentsToUpload, setDocumentsToUpload] = useState<IDocumentsToUpload>([])
  const { onContinueAcOpening } = useGetStep()
  const navigate = useNavigate();

  const handleMoveToDocumentsScreen = () => {
    setModificationScreenIndex((prev) => prev + 1)
  }

  // In modification step,
  // we for liveliness detection step, we are redirect to the same old component
  // for personal details and documents upload, we have created new screens, which are in this component
  useEffect(() => {
    if (Object.keys(userDetails.rejectedSteps).length) {
      const { rejectedSteps } = userDetails
      if (rejectedSteps?.liveliness_detection) {
        navigate("/verify-image")
      } else {
        setModificationSteps(Object.keys(rejectedSteps) as Step[])
      }
    } else {
      const step = onContinueAcOpening();
      navigate(step);
    }
  }, [userDetails])

  useEffect(() => {
    if (modificationSteps.length) {
      if (modificationSteps.includes("personal_details")) {
        setModificationScreens((prev) => [...prev, "personal_details"])
      }
      if (modificationSteps.includes("pan_image_upload")
        || modificationSteps.includes("signature")
        || modificationSteps.includes("income_proof")) {
        setModificationScreens((prev) => [...prev, "documents_upload"])
      }
      setDocumentsToUpload(modificationSteps.filter((step) => step !== "personal_details") as IDocument[])
    }
  }, [modificationSteps])

  return modificationScreens.length
    ? (
      <>
        {modificationScreens[modificationScreenIndex] === "documents_upload"
        && <DocumentsUpload documentsToUpload={documentsToUpload} />}
        {modificationScreens[modificationScreenIndex] === "personal_details" && (
        <PersonalDetailsEdit
          handleMoveToDocumentsScreen={handleMoveToDocumentsScreen}
        />
        )}
      </>
    )
    : null
}
